import React from 'react';
import {
  IonTabs,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonIcon,
  IonLabel,
} from '@ionic/react';
import { Redirect, Route } from 'react-router-dom';
import {
  barChartOutline,
  cartOutline,
  analyticsOutline,
  restaurantOutline,
  ellipsisHorizontalOutline,
  cubeOutline,
} from 'ionicons/icons';
import Dashboard from '../pages/Dashboard';
import Orders from '../pages/Orders';
import OrderForm from '../pages/OrderForm';
import Analytics from '../pages/Analytics';
import Materials from '../pages/Materials';
import MaterialForm from '../pages/MaterialForm';
import MaterialDetail from '../pages/MaterialDetail';
import MaterialImport from '../pages/MaterialImport';
import Recipes from '../pages/Recipes';
import RecipeDetail from '../pages/RecipeDetail';
import ProcessedMaterials from '../pages/ProcessedMaterials';
import ProcessedMaterialDetail from '../pages/ProcessedMaterialDetail';
import ManufactureForm from '../pages/ManufactureForm';
import ProcessedMaterialForm from '../pages/ProcessedMaterialForm';
import RecipeEdit from '../pages/RecipeEdit';
import Users from '../pages/Users';
import Inventory from '../pages/Inventory';
import Warehouses from '../pages/Warehouses';
import Assets from '../pages/Assets';
import Products from '../pages/Products';
import More from '../pages/More';
import Customers from '../pages/Customers';
import Categories from '../pages/Categories';
import CategoryTags from '../pages/CategoryTags';
import ActionLogs from '../pages/ActionLogs';
import MenuManagement from '../pages/MenuManagement';
import { useLanguage } from '../context/LanguageContext';

const MainTabs: React.FC = () => {
  const { t } = useLanguage();

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Route path="/tabs/dashboard" component={Dashboard} exact />
        <Route path="/tabs/orders" component={Orders} exact />
        <Route path="/tabs/orders/new" component={OrderForm} exact />
        <Route path="/tabs/analytics" component={Analytics} exact />
        <Route path="/tabs/products" component={Products} exact />
        <Route path="/tabs/recipes" component={Recipes} exact />
        <Route path="/tabs/recipes/:id" component={RecipeDetail} exact />
        <Route path="/tabs/recipes/:id/edit" component={RecipeEdit} exact />
        <Route path="/tabs/materials" component={Materials} exact />
        <Route path="/tabs/materials/new" component={MaterialForm} exact />
        <Route
          path="/tabs/materials/:id([0-9a-fA-F-]{36})"
          component={MaterialDetail}
          exact
        />
        <Route
          path="/tabs/materials/:id([0-9a-fA-F-]{36})/import"
          component={MaterialImport}
          exact
        />
        <Route path="/tabs/users" component={Users} exact />
        <Route path="/tabs/customers" component={Customers} exact />
        <Route path="/tabs/manufacturing/new" component={ProcessedMaterialForm} exact />
        <Route
          path="/tabs/manufacturing/:id([0-9a-fA-F-]{36})/edit"
          component={ProcessedMaterialForm}
          exact
        />
        <Route
          path="/tabs/manufacturing/:id([0-9a-fA-F-]{36})/produce"
          component={ManufactureForm}
          exact
        />
        <Route
          path="/tabs/manufacturing/:id([0-9a-fA-F-]{36})"
          component={ProcessedMaterialDetail}
          exact
        />
        <Route path="/tabs/manufacturing" component={ProcessedMaterials} exact />
        <Route path="/tabs/inventory" component={Inventory} exact />
        <Route path="/tabs/warehouses" component={Warehouses} exact />
        <Route path="/tabs/assets" component={Assets} exact />
        <Route path="/tabs/categories" component={Categories} exact />
        <Route path="/tabs/category-tags" component={CategoryTags} exact />
        <Route path="/tabs/action-logs" component={ActionLogs} exact />
        <Route path="/tabs/menu" component={MenuManagement} exact />
        <Route path="/tabs/more" component={More} exact />
        <Route exact path="/tabs">
          <Redirect to="/tabs/dashboard" />
        </Route>
      </IonRouterOutlet>

      <IonTabBar slot="bottom">
        <IonTabButton tab="dashboard" href="/tabs/dashboard">
          <IonIcon icon={barChartOutline} />
          <IonLabel>{t('dashboard')}</IonLabel>
        </IonTabButton>
        <IonTabButton tab="orders" href="/tabs/orders">
          <IonIcon icon={cartOutline} />
          <IonLabel>{t('orders')}</IonLabel>
        </IonTabButton>
        <IonTabButton tab="products" href="/tabs/products">
          <IonIcon icon={cubeOutline} />
          <IonLabel>{t('products') || 'Products'}</IonLabel>
        </IonTabButton>
        <IonTabButton tab="analytics" href="/tabs/analytics">
          <IonIcon icon={analyticsOutline} />
          <IonLabel>{t('analytics')}</IonLabel>
        </IonTabButton>
        <IonTabButton tab="recipes" href="/tabs/recipes">
          <IonIcon icon={restaurantOutline} />
          <IonLabel>{t('recipes')}</IonLabel>
        </IonTabButton>
        <IonTabButton tab="more" href="/tabs/more">
          <IonIcon icon={ellipsisHorizontalOutline} />
          <IonLabel>{t('more') ?? 'More'}</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

export default MainTabs;
